import { render, staticRenderFns } from "./RegistrationVerification.vue?vue&type=template&id=787445b8&scoped=true"
import script from "./RegistrationVerification.vue?vue&type=script&lang=js"
export * from "./RegistrationVerification.vue?vue&type=script&lang=js"
import style0 from "./RegistrationVerification.vue?vue&type=style&index=0&id=787445b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Users/afei/podcod_saas_project/shoppaas_member_front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787445b8",
  null
  
)

export default component.exports